export default {
  allSeverityLevels: 'All severity levels',
  zeroSeverityLevels: '0 severity levels are selected',
  severityLevels: 'Severity levels',
};
